<script setup lang="ts">
import UniversalFilterTree from '@/components/createdUi/UniversalFilterTree.vue'

const props = defineProps<{
  store: any
  tempSelectedFilters: Record<string, any[]>
  filterMenus: Record<string, boolean>
  getFilterIcon: (isActive: boolean) => string
}>()

const emit = defineEmits<{
  'filter-click': [fieldKey: string]
  'filter-apply': [fieldKey: string]
}>()

const isServiceFilterActive = computed(() =>
  (props.store.filters.service?.length ?? 0) > 0,
)
const isPriorityFilterActive = computed(() =>
  (props.store.filters.priority?.length ?? 0) > 0,
)

const applyFilter = (filterKey: string) => {
  emit('filter-apply', filterKey)
}

const handleFilterClick = (filterKey: string) => {
  emit('filter-click', filterKey)
}
</script>

<template>
  <VMenu v-model="filterMenus.service" :close-on-content-click="false" location="bottom start">
    <template #activator="{ props: menuProps }">
      <VBtn
        v-bind="menuProps"
        :prepend-icon="getFilterIcon(isServiceFilterActive)"
        variant="outlined"
        color="secondary"
        class="text-color-secondary"
        :loading="store.filterLoading.service"
        :class="{ 'active-filter': isServiceFilterActive }"
        @click="handleFilterClick('service')"
      >
        Служба
      </VBtn>
    </template>
    <UniversalFilterTree
      field-key="service"
      module="ticket"
      :store="store"
      :model-value="tempSelectedFilters.service || []"
      placeholder="Поиск службы"
      @update:model-value="tempSelectedFilters.service = $event"
      @apply="applyFilter('service')"
    />
  </VMenu>

  <VMenu v-model="filterMenus.priority" :close-on-content-click="false" location="bottom start">
    <template #activator="{ props: menuProps }">
      <VBtn
        v-bind="menuProps"
        :prepend-icon="getFilterIcon(isPriorityFilterActive)"
        variant="outlined"
        color="secondary"
        class="text-color-secondary"
        :loading="store.filterLoading.priority"
        :class="{ 'active-filter': isPriorityFilterActive }"
        @click="handleFilterClick('priority')"
      >
        Приоритет
      </VBtn>
    </template>
    <UniversalFilterTree
      field-key="priority"
      module="ticket"
      :store="store"
      :model-value="tempSelectedFilters.priority || []"
      placeholder="Поиск приоритета"
      @update:model-value="tempSelectedFilters.priority = $event"
      @apply="applyFilter('priority')"
    />
  </VMenu>
</template>

<style scoped lang="scss">
.active-filter {
  border-color: rgb(var(--v-theme-primary)) !important;
  color: rgb(var(--v-theme-primary)) !important;
}
</style>
